$(() => {
  accLinksTriggerActive();
});
function accLinksTriggerActive() {
  const url = window.location.pathname;
  console.log("asd");
  $(".customer-links__link").each((i, el) => {
    const $el = $(el);
    console.log(url);
    console.log($el.attr("href").indexOf(url));
    if ($el.attr("href").indexOf(url) !== -1) {
      $el.addClass("customer-links__link--is-active");
    }
  });
}
if (module.hot) { module.hot.accept(); }